import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function fetchArchiveVideoDetails(params) {
  return axios.get(apiUrl.archive.GET.DETAIL, { params });
}

export function fetchArchiveVideoDownloadUrl(jobId) {
  const url = apiUrl.archive.GET.DOWNLOAD.replace("{jobId}", jobId);
  return axios.get(url);
}

export function createArchiveVideo(data) {
  return axios.post(apiUrl.archive.POST, data);
}
